import { render, staticRenderFns } from "./PropertyCatalog.vue?vue&type=template&id=0fee9a29&scoped=true&"
import script from "./PropertyCatalog.vue?vue&type=script&lang=js&"
export * from "./PropertyCatalog.vue?vue&type=script&lang=js&"
import style0 from "./PropertyCatalog.vue?vue&type=style&index=0&id=0fee9a29&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fee9a29",
  null
  
)

export default component.exports